import React from 'react';
import ReactDOM from 'react-dom';
import AppComponent from './App';
import "./custom-boostrap-theme.scss";
import './index.css';
import "./style/custom.css";
import {InitDataContextProvider} from "./utils/InitDataContextProvider";
import * as serviceWorker from './serviceWorker';

ReactDOM.render(
    <React.StrictMode>
        <InitDataContextProvider>
            <AppComponent />
        </InitDataContextProvider>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
